import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Link } from "react-router-dom";
import { Modal } from "reactstrap";
import { Baseurl } from "../../../config/BaseUrl";
import axios from "axios";
import { authActions } from "../../../redux/athentication/Athentication";
import { toast } from "react-toastify";
import { viewdStatuschange } from "../../../redux/userViewdProperty/UserViewdPropertySlice";
import { IoStar, IoStarOutline } from "react-icons/io5";
import {
  FiDownload,
  FiUsers,
  FiPhone,
  FiMail,
  FiCalendar,
  FiCheckCircle,
  FiExternalLink,
} from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import ResponsesNewModal from "./propertyReCalmodel/ResponsesNewModal";
import "./DashboardListingsNew.css";

const AllResponse = ({ searchTerm = "" }) => {
  const { loginData } = useSelector((store) => store.Athentication);
  const dispatch = useDispatch();

  const [modal, setModal] = useState(false);
  const [response, setResponse] = useState([]);
  const [temploading, setTemploading] = useState(true);
  const toggle = () => setModal(!modal);

  useEffect(() => {
    let isMounted = true;
    const fetchdata = async () => {
      try {
        if (!loginData?._id) {
          if (isMounted) setTemploading(false);
          return;
        }
        const url = `${Baseurl}/api/v1/viewed/responsebypostuser/${loginData._id}`;
        const fetchResponse = await axios.get(url);
        if (fetchResponse.data && fetchResponse.data.success === true) {
          const singleResponse = fetchResponse.data.userResponseByPostUser || [];
          if (isMounted) {
            setResponse(singleResponse);
            setTemploading(false);
          }
        } else {
          if (isMounted) setTemploading(false);
        }
      } catch (error) {
        if (isMounted) setTemploading(false);
      }
    };
    fetchdata();
    return () => {
      isMounted = false;
    };
  }, [loginData?._id]);

  const viewResponseClick = async (e, property) => {
    if (e) e.preventDefault();
    const propertyVerifyData = {
      propertyId: property.propertyId,
      postUserId: loginData?._id,
    };
    const config = {
      headers: { "Content-Type": "application/json" },
    };
    const verifyurl = `${Baseurl}/api/v1/viewed/viewedpropertyverifynew`;

    try {
      const propertyVerify = await axios.post(
        verifyurl,
        propertyVerifyData,
        config
      );

      if (propertyVerify.data && propertyVerify.data.success === true) {
        if (propertyVerify.data.userViewedProperty?.length > 0) {
          const propertyformdata = {
            id: property._id,
            leadsView: true,
          };
          const viewupdateurl = `${Baseurl}/api/v1/viewed/update/${propertyformdata.id}`;
          const fetchData = await axios.put(viewupdateurl, propertyformdata);
          if (fetchData.data && fetchData.data.success === true) {
            setResponse((prev) =>
              prev.map((data) =>
                data._id === property._id ? { ...data, leadsView: true } : data
              )
            );
            toast.success("Lead details unlocked successfully!");
          }
        } else {
          const formdata = {
            mobile: loginData?.mobile,
            creadittospent: 1,
          };
          const url = `${Baseurl}/api/v1/user/shopUserByMobile`;
          const fetchData = await axios.put(url, formdata);

          if (fetchData.data && fetchData.data.success) {
            const authenticForm = {
              ...fetchData.data.user,
              isAuth: true,
            };
            dispatch(authActions.signIn(authenticForm));
            dispatch(viewdStatuschange(property));

            const propertyformdata = {
              id: property._id,
              leadsView: true,
            };
            const viewupdateurl = `${Baseurl}/api/v1/viewed/update/${propertyformdata.id}`;
            await axios.put(viewupdateurl, propertyformdata);

            setResponse((prev) =>
              prev.map((data) =>
                data._id === property._id ? { ...data, leadsView: true } : data
              )
            );
            toast.success("Contact unlocked (1 credit deducted)!");
          } else {
            toast.error("Insufficient credits. Please recharge your wallet.", {
              position: "top-center",
              autoClose: 2000,
            });
          }
        }
      }
    } catch (error) {
      toast.error("Unable to unlock contact. Please try again.");
    }
  };

  const filteredResponses = (response || []).filter((item) => {
    if (!searchTerm || !searchTerm.trim()) return true;
    const term = searchTerm.toLowerCase().trim();
    return (
      (item.userName && item.userName.toLowerCase().includes(term)) ||
      (item.userMobile && String(item.userMobile).includes(term)) ||
      (item.propertyName && item.propertyName.toLowerCase().includes(term)) ||
      (item.userEmail && item.userEmail.toLowerCase().includes(term)) ||
      (item.propertyId && String(item.propertyId).toLowerCase().includes(term))
    );
  });

  return (
    <div className="mgh-dl-container">
      {/* ================= Header Info Bar ================= */}
      <div className="mgh-dl-info-bar">
        <h4 className="mgh-dl-count-heading">
          <span>Buyer Inquiries & Leads</span>
          <span className="mgh-dl-count-pill">
            {filteredResponses.length}{" "}
            {filteredResponses.length === 1 ? "Inquiry" : "Inquiries"}
          </span>
        </h4>

        <div className="mgh-dl-filters-row">
          <span className="mgh-dl-filter-tag">
            <span>Showing: All Inquiries</span>
          </span>
          {filteredResponses.length > 0 && (
            <button
              type="button"
              className="mgh-lead-btn-download"
              onClick={() => setModal(true)}
              title="Download CSV"
            >
              <FiDownload size={14} />
              <span>Download CSV</span>
            </button>
          )}
        </div>
      </div>

      {/* ================= CSV Download Modal ================= */}
      <Modal isOpen={modal} toggle={toggle} className="modalmainnew" centered>
        <ResponsesNewModal response={response} toggle={toggle} />
      </Modal>

      {/* ================= Inquiries List ================= */}
      {temploading ? (
        <div className="mgh-dl-empty-state" style={{ padding: "40px" }}>
          <div
            className="spinner-border text-warning"
            role="status"
            style={{ width: "2.5rem", height: "2.5rem" }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mgh-dl-empty-desc" style={{ marginTop: "12px" }}>
            Loading inquiries...
          </p>
        </div>
      ) : filteredResponses.length > 0 ? (
        filteredResponses.map((view, index) => {
          const buyerInitial = (view.userName || "U")
            .trim()
            .charAt(0)
            .toUpperCase();
          const cleanMobile = String(view.userMobile || "").replace(/\D/g, "");

          return (
            <div className="mgh-lead-card" key={view._id || index}>
              <div className="mgh-lead-card-main">
                {/* 1. Buyer Profile */}
                <div className="mgh-lead-buyer-wrap">
                  <div className="mgh-lead-avatar">{buyerInitial}</div>
                  <div className="mgh-lead-buyer-details">
                    <h4 className="mgh-lead-buyer-name" title={view.userName}>
                      {view.userName || "Interested Buyer"}
                    </h4>
                    <p className="mgh-lead-buyer-contact">
                      <span>+91-{view.userMobile}</span>
                      <span className="mgh-lead-verified-badge">
                        <FiCheckCircle size={11} /> Verified
                      </span>
                    </p>
                    {view.userEmail && (
                      <a
                        href={`mailto:${view.userEmail}`}
                        className="mgh-lead-buyer-email"
                        title={view.userEmail}
                      >
                        {view.userEmail}
                      </a>
                    )}
                  </div>
                </div>

                {/* 2. Rating & Activity */}
                <div className="mgh-lead-score-wrap">
                  <div className="mgh-lead-rating-row">
                    <span className="mgh-lead-rating-num">3.0</span>
                    <div className="mgh-lead-rating-stars">
                      <IoStar color="#f59e0b" size={15} />
                      <IoStar color="#f59e0b" size={15} />
                      <IoStar color="#f59e0b" size={15} />
                      <IoStarOutline color="#cbd5e1" size={15} />
                      <IoStarOutline color="#cbd5e1" size={15} />
                    </div>
                  </div>
                  <p className="mgh-lead-date-label">
                    <FiCalendar size={12} style={{ marginRight: "4px" }} />
                    Viewed on{" "}
                    {moment(view.createdAt).format("DD MMM YYYY")}
                  </p>
                </div>

                {/* 3. Property Information */}
                <div className="mgh-lead-prop-wrap">
                  {view.propertyId && (
                    <span className="mgh-lead-prop-id">
                      ID: {String(view.propertyId).slice(0, 8)}
                    </span>
                  )}
                  <h5 className="mgh-lead-prop-title">
                    {view.propertyName || "Property Listing"}
                  </h5>
                  <p className="mgh-lead-prop-price">
                    {view.price
                      ? `Rs. ${Number(view.price).toLocaleString("en-IN")}`
                      : "Price On Request"}
                    {view.noofBedrooms ? ` • ${view.noofBedrooms} BHK` : ""}
                    {view.category ? ` • ${view.category}` : ""}
                    {view.propertyStatus ? ` (${view.propertyStatus})` : ""}
                  </p>
                </div>
              </div>

              {/* Card Footer / Action Buttons */}
              <div className="mgh-lead-footer">
                <div className="mgh-lead-actions">
                  {cleanMobile && (
                    <>
                      <a
                        href={`tel:+91${cleanMobile}`}
                        className="mgh-lead-btn mgh-lead-btn-call"
                      >
                        <FiPhone size={13} />
                        <span>Call Buyer</span>
                      </a>
                      <a
                        href={`https://wa.me/91${cleanMobile}?text=Hello%20${encodeURIComponent(
                          view.userName || "Sir/Madam"
                        )},%20regarding%20your%20inquiry%20on%20MyGoldenHomes.`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mgh-lead-btn mgh-lead-btn-wa"
                      >
                        <FaWhatsapp size={14} />
                        <span>WhatsApp</span>
                      </a>
                    </>
                  )}
                </div>

                <div>
                  {!view.leadsView && (
                    <button
                      type="button"
                      className="mgh-dl-response-btn"
                      onClick={(e) => viewResponseClick(e, view)}
                    >
                      Unlock Contact (1 Credit)
                    </button>
                  )}
                </div>
              </div>
            </div>
          );
        })
      ) : (
        /* Modern Empty State */
        <div className="mgh-dl-empty-state">
          <div className="mgh-dl-empty-icon">
            <FiUsers size={28} />
          </div>
          <h3 className="mgh-dl-empty-title">No Inquiries or Leads Yet</h3>
          <p className="mgh-dl-empty-desc">
            You haven't received any buyer or tenant inquiries for your listings
            yet. Post more properties or boost your listings to start receiving
            verified buyer leads!
          </p>
          <div
            style={{
              display: "flex",
              gap: "10px",
              flexWrap: "wrap",
              justifyContent: "center",
              marginTop: "4px",
            }}
          >
            <Link
              to="/postPropertyHome"
              className="mgh-dl-boost-btn"
              style={{ textDecoration: "none" }}
            >
              + Post Property FREE
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default AllResponse;
